import PropTypes from "prop-types";
import React, { createContext, useContext, useState } from "react";
import { login as LOGIN } from "../utilities/apis";

const ApplicationContext = createContext();

function useProvider() {
  const [user, setUser] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [exams, setExams] = useState([]);

  const login = (credentials, callback) => {
    LOGIN(credentials, (error, result) => {
      if (error) return callback(error);
      if (result && result.user) setUser(result.user);
      if (result && result.departments) setDepartments(result.departments);
      if (result && result.exams) setExams(result.exams);
      callback(null);
    });
  };

  const logout = () => {
    setUser(null);
    setDepartments([]);
    setExams([]);
  };

  return { user, departments, exams, login, logout };
}

function useAuth() {
  const context = useContext(ApplicationContext);

  if (context === undefined) {
    throw new Error("useAuth must be used within ApplicationProvider");
  }
  const { login, logout } = context;

  return { login, logout };
}

function useUser() {
  const context = useContext(ApplicationContext);

  if (context === undefined) {
    throw new Error("useUser must be used within ApplicationProvider");
  }

  return context.user;
}

/**
 * hook for departments
 */

function useDepartments() {
  const context = useContext(ApplicationContext);

  if (context === undefined) {
    throw new Error("useDepartments must be used within ApplicationProvider");
  }

  return context.departments;
}
/**
 * hook for exams
 */
function useExams() {
  const context = useContext(ApplicationContext);
  if (context === undefined) {
    throw new Error("useExams must be used within ApplicationProvider");
  }
  return context.exams;
}

/**
 * Provider for entire application
 * @param {Object} children
 */

const ApplicationProvider = ({ children }) => {
  const provider = useProvider();

  return (
    <ApplicationContext.Provider value={provider}>
      {children}
    </ApplicationContext.Provider>
  );
};

ApplicationProvider.propTypes = {
  children: PropTypes.object,
};

export { ApplicationProvider, useAuth, useDepartments, useExams, useUser };
